import styled from "styled-components";

export const StyledCookieMessageWrapper = styled.div`
  width: 100%;
  background: linear-gradient(-195.8deg, #FFFFFF -2.63%, #ddc6ff 113.92%, #F3F2F2 113.94%);
  border-top: 2px solid #c0b1d6;
  padding: 15px 0;
  position: fixed;
  bottom: 0;
  z-index: 99999;
`;

export const StyledCookieMessageContainer = styled.div`
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  grid-gap: 15px;
  h4 {
    color: ${({ theme }) => theme.main};
    font-size: 16px;
  }
  p {
    padding: 10px 0;
    text-align: justify;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 100%;
    text-align: center;
    p {
      text-align: center;
    }
  }
`;

export const StyledCookieMessageContent = styled.div`
  a {
    color: ${({ theme }) => theme.main};    
  }
`;

export const StyledCookieMessageAction = styled.div`
  display: grid;
  grid-gap: 15px;
  button {
    letter-spacing: normal;
  }
`;

export const StyledCookiePreferenceWrapper = styled.div``;

export const StyledCookiePreference = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 2px solid #A9A9A9;
  .preference-item {
    padding-bottom: 15px;
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 15px;
    h5 {
      padding-bottom: 5px;
      color: ${({ theme }) => theme.main};
      font-size: 16px;
    }
  }

  .readOnly {
    opacity: 0.5;
  }
`;